import createSelector from 'web-app/util/custom-create-selector';
import {type RootState} from 'web-app/react/redux/main-reducer';

export const getMealTypes = (state: RootState) => state.entities.meals.mealPlan.mealTypes;

export const getMealTypesForInstitution = createSelector(
    getMealTypes,
    (state: RootState, props: {institutionId: string}) => props.institutionId,
    (mealTypes, institutionId) => mealTypes.get(institutionId),
);

export const getMealType = createSelector(
    getMealTypesForInstitution,
    (state: RootState, props: {institutionId: string}) => props.institutionId,
    (state: RootState, props: {mealTypeId: string}) => props.mealTypeId,
    (mealTypes, institutionId, mealTypeId) =>
        typeof mealTypes === 'object' ? mealTypes.find(mealType => mealType.id === mealTypeId) : null,
);
